// console.log('app.js loaded');
// function replaceRegisteredSymbolsInText(node) {
//     if (node.nodeType === Node.TEXT_NODE) {
//         // Zamień znaki &reg; lub ® tylko w tekstowych węzłach
//         node.nodeValue = node.nodeValue.replace(/(®|&reg;)/g, '<sup class="milwaukee_reg">$1</sup>');
//     } else {
//         // Iteruj przez dzieci węzła
//         node.childNodes.forEach(child => replaceRegisteredSymbolsInText(child));
//     }
// }

// Rozpocznij od korzenia dokumentu (document.body)
// replaceRegisteredSymbolsInText(document.body);
 
$mainMenu = document.querySelector("#main_menu");

console.log('=== DEBUG MENU ===');
console.log('Main menu znaleziony:', $mainMenu);

if ($mainMenu) {
  const isMobileMenu = isMobileAndSmallScreen();
  console.log('isMobileMenu:', isMobileMenu);

  if (!isMobileMenu) {
  const navImageContainers = document.querySelectorAll(".nav__image");
  const navButtonContainers = document.querySelectorAll(".nav__button");
  const allElements = document.querySelectorAll("[data-sub-item]");
  console.log('Wszystkie elementy z data-sub-item:', allElements.length);
  const linksNoHref = document.querySelectorAll("[data-sub-item='00']");

  linksNoHref.forEach( function( link ) {
    link.addEventListener('click', function(event) {
      console.log(event.target)
    });
  } )
  // number indicates item level in menu hierarchy, modified wp nav structure is in /functions/main-menu-walker.php
  const elements0 = document.querySelectorAll('[data-sub-item="00"]');
  console.log('Elements0:', elements0.length);
  // Dodatkowa obsługa kategorii głównych produktów (depth-0)
  const productMainCategories = document.querySelectorAll('.depth-0 > a[data-sub-item]');
  console.log('Product main categories selektor .depth-0 > a[data-sub-item]:', productMainCategories.length);
  
  // Sprawdźmy też inne możliwe selektory
  const depthZeroItems = document.querySelectorAll('.depth-0');
  console.log('Wszystkie .depth-0:', depthZeroItems.length);
  const depthZeroLinks = document.querySelectorAll('.depth-0 a');
  console.log('Wszystkie .depth-0 a:', depthZeroLinks.length);

  allElements.forEach(function (element) {
    element.addEventListener("click", function (event) {
      const imageUrl = event.target.getAttribute("data-image");
      const linkLabel = event.target.getAttribute("data-link-label");
      const linkUrl = event.target.getAttribute("data-link-url");

      if (!event.target.classList.contains("active")) {
        if (imageUrl) {
          navImageContainers.forEach(function (imageContainer) {
            imageContainer.style.backgroundImage = "url(" + imageUrl + ")";
            imageContainer.removeAttribute("hidden");
          });
        } else {
          navImageContainers.forEach(function (imageContainer) {
            imageContainer.style.backgroundImage = "url()";
            imageContainer.setAttribute("hidden", true);
          });
        }

        if (linkLabel) {
          navButtonContainers.forEach(function (buttonContainer) {
            buttonContainer.innerText = linkLabel;
          });
        } else {
          navButtonContainers.forEach(function (buttonContainer) {
            buttonContainer.innerText = "";
          });
        }

        if (linkUrl) {
          navButtonContainers.forEach(function (buttonContainer) {
            buttonContainer.setAttribute("href", linkUrl);
          });
        } else {
          navButtonContainers.forEach(function (buttonContainer) {
            buttonContainer.removeAttribute("href");
          });
        }
      } else {
        navImageContainers.forEach(function (imageContainer) {
          imageContainer.style.backgroundImage = "url()";
          imageContainer.setAttribute("hidden", true);
        });
        navButtonContainers.forEach(function (buttonContainer) {
          buttonContainer.innerText = "";
        });
        navButtonContainers.forEach(function (buttonContainer) {
          buttonContainer.removeAttribute("href");
        });
      }
    });
  });
  function removeActiveFromElements0() {
    // elements0.forEach(function (item) {
    //   //   item.classList.remove("active");
    // });
  }
  
  // Obsługa kategorii głównych produktów - tylko click
  console.log('Znaleziono kategorii głównych:', productMainCategories.length);
  
  // Daj event listener na LI zamiast na A, żeby złapać klik na całym elemencie
  const productMainCatLis = document.querySelectorAll('li.depth-0.menu-item-has-children');
  console.log('LI depth-0 z dziećmi:', productMainCatLis.length);
  
  productMainCatLis.forEach(function (li) {
    li.addEventListener("click", function (event) {
      // Jeśli kliknięto w link wewnątrz submenu lub w cat-popup - nie blokuj
      if (event.target.closest('.menu__lvl_2')) return;
      
      event.preventDefault();
      event.stopPropagation();
      
      const submenu = li.querySelector('.menu__lvl_2');
      const isOpen = submenu && submenu.style.display === 'block';
      
      // Zamknij wszystkie inne
      productMainCatLis.forEach(function (otherLi) {
        if (otherLi !== li) {
          const otherSubmenu = otherLi.querySelector('.menu__lvl_2');
          if (otherSubmenu) otherSubmenu.style.display = 'none';
          otherLi.querySelector('a[data-sub-item]') && otherLi.querySelector('a[data-sub-item]').classList.remove('active');
        }
      });
      elements0.forEach(function (el) { el.classList.remove("active"); });
      
      // Toggle
      if (isOpen) {
        if (submenu) submenu.style.display = 'none';
        const a = li.querySelector('a[data-sub-item]');
        if (a) a.classList.remove('active');
      } else {
        if (submenu) submenu.style.display = 'block';
        const a = li.querySelector('a[data-sub-item]');
        if (a) a.classList.add('active');
      }
    });
  });
  
  productMainCategories.forEach(function (element) {
    element.addEventListener("click", function (event) {
      event.preventDefault();
      event.stopPropagation(); // Zapobiega podwójnemu wywołaniu przez handler na LI
      const currentElement = event.currentTarget;
      const li = currentElement.closest('li.depth-0');
      const submenu = li ? li.querySelector('.menu__lvl_2') : null;

      // Ukryj wszystkie inne submenu
      productMainCategories.forEach(function (el) {
        if (el !== currentElement) {
          el.classList.remove("active");
          const otherLi = el.closest('li.depth-0');
          const otherSubmenu = otherLi ? otherLi.querySelector('.menu__lvl_2') : null;
          if (otherSubmenu) otherSubmenu.style.display = 'none';
        }
      });
      elements0.forEach(function (el) {
        el.classList.remove("active");
      });

      // Toggle aktualnego
      if (currentElement.classList.contains("active")) {
        currentElement.classList.remove("active");
        if (submenu) submenu.style.display = 'none';
      } else {
        currentElement.classList.add("active");
        if (submenu) submenu.style.display = 'block';
      }
    });
  });
  
  elements0.forEach(function (element) {
    element.addEventListener("click", function (event) {
      event.preventDefault(); // Dodane preventDefault
      const currentElement = event.currentTarget; // Zmienione z target na currentTarget
      
      // Usuń active również z kategorii głównych produktów
      productMainCategories.forEach(function (el) {
        el.classList.remove("active");
      });
      
      elements0.forEach(function (el) {
        if ( el !== currentElement ){ // Zmienione != na !==
          el.classList.remove("active");
        }
      });

      if (currentElement.classList.contains("active")) {
        currentElement.classList.remove("active");
        removeActiveFromElements0();
      } else {
        removeActiveFromElements0();
        currentElement.classList.add("active");
      }
    });
  });

  // Zamknij menu po kliknięciu poza nim
  document.addEventListener("click", function (event) {
    let clickedOutsideElements0 = true;
    for (let element of elements0) {
      if (element.contains(event.target)) {
        clickedOutsideElements0 = false;
        break;
      }
    }
    let clickedOutsideCategories = true;
    for (let element of productMainCategories) {
      const li = element.closest('li');
      if (li && li.contains(event.target)) {
        clickedOutsideCategories = false;
        break;
      }
    }

    if (clickedOutsideElements0) {
      removeActiveFromElements0();
    }
    if (clickedOutsideCategories) {
      productMainCategories.forEach(function (el) {
        el.classList.remove("active");
        const submenu = el.closest('li.depth-0') ? el.closest('li.depth-0').querySelector('.menu__lvl_2') : null;
        if (submenu) submenu.style.display = 'none';
      });
    }
  });

  } // closes if (!isMobileMenu)

  if (isMobileMenu) {
    initMobileMenuPanels();
  }
}

// Drag to scroll dla desktop_categories
const desktopCategories = document.querySelector('.desktop_categories');
if (desktopCategories) {
  let isDown = false;
  let startX;
  let scrollLeft;
  let hasMoved = false;

  desktopCategories.addEventListener('mousedown', function(e) {
    isDown = true;
    hasMoved = false;
    startX = e.pageX - desktopCategories.offsetLeft;
    scrollLeft = desktopCategories.scrollLeft;
  });

  desktopCategories.addEventListener('mouseleave', function() {
    isDown = false;
  });

  desktopCategories.addEventListener('mouseup', function() {
    isDown = false;
  });

  desktopCategories.addEventListener('mousemove', function(e) {
    if (!isDown) return;
    e.preventDefault();
    hasMoved = true;
    const x = e.pageX - desktopCategories.offsetLeft;
    const walk = (x - startX) * 2; // Mnożnik kontroluje szybkość przewijania
    desktopCategories.scrollLeft = scrollLeft - walk;
  });

  // Zapobiegnij kliknięciu linków podczas przeciągania
  desktopCategories.addEventListener('click', function(e) {
    if (hasMoved) {
      e.preventDefault();
      e.stopPropagation();
    }
  }, true);
}

function isMobileAndSmallScreen() {
  const userAgent = navigator.userAgent;
  const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(userAgent);
  const isLargeScreen = window.innerWidth < 961;

  return isMobile || isLargeScreen;
}

function initDesktopMegaMenuLayout() {
  if (isMobileAndSmallScreen()) {
    return;
  }

  // Obsługa wszystkich kategorii głównych z podmenu (zamiast tylko .menu-item-products)
  const menuContainers = document.querySelectorAll(
    ".depth-0.menu-item-has-children .primary_submenu"
  );
  menuContainers.forEach((container) => {
    if (container.dataset.megaReady === "true") {
      return;
    }

    const items = Array.from(container.querySelectorAll("li[data-depth]"));
    if (!items.length) {
      return;
    }

    const itemsById = new Map();
    items.forEach((item) => {
      itemsById.set(item.getAttribute("data-id"), item);
      item.classList.remove("not_showing");
    });

    items.forEach((item) => {
      const depth = Number(item.getAttribute("data-depth"));
      if (depth <= 1) {
        return;
      }

      const parentId = item.getAttribute("data-parent-id");
      const parent = itemsById.get(parentId);
      if (!parent) {
        return;
      }

      let subList = parent.querySelector(":scope > .mega-submenu");
      if (!subList) {
        subList = document.createElement("ul");
        subList.classList.add("mega-submenu", "mega-submenu--depth-" + depth);
        parent.appendChild(subList);
      }
      subList.appendChild(item);
    });

    const depth1Items = Array.from(
      container.querySelectorAll('li[data-depth="1"]')
    );

    container.innerHTML = "";
    depth1Items.forEach((item) => {
      container.appendChild(item);
    });

    container.dataset.megaReady = "true";
  });
}

function initMobileMenuPanels() {
  const offcanvasBar = document.querySelector("#mobile-menu .uk-offcanvas-bar");
  if (!offcanvasBar || offcanvasBar.dataset.mobilePanelsInit === "true") {
    return;
  }

  const rootNav = offcanvasBar.querySelector(".nav");
  if (!rootNav) {
    return;
  }

  offcanvasBar.dataset.mobilePanelsInit = "true";

  // Legacy menu markup marks deeper levels as hidden; mobile accordion needs them visible.
  rootNav.querySelectorAll(".not_showing").forEach((item) => {
    item.classList.remove("not_showing");
  });

  const getDirectSubmenu = (listItem) => {
    if (!listItem) {
      return null;
    }

    const children = Array.from(listItem.children);
    const levelWrapper = children.find(
      (child) => child.classList && child.classList.contains("menu__lvl_2")
    );

    if (levelWrapper) {
      const nestedSubmenu = levelWrapper.querySelector(".sub-menu");
      if (nestedSubmenu) {
        return nestedSubmenu;
      }
    }

    const directSubmenu = children.find(
      (child) => child.classList && child.classList.contains("sub-menu")
    );
    if (directSubmenu) {
      return directSubmenu;
    }

    return listItem.querySelector(".sub-menu");
  };

  const getDirectLink = (listItem) => {
    if (!listItem) {
      return null;
    }

    const children = Array.from(listItem.children);
    const directAnchor = children.find((child) => child.tagName === "A");
    if (directAnchor) {
      return directAnchor;
    }

    const triggerWrap = children.find(
      (child) => child.classList && child.classList.contains("item_triggers")
    );
    if (!triggerWrap) {
      return null;
    }

    return triggerWrap.querySelector("a");
  };

  const closeBranch = (listItem) => {
    if (!listItem) {
      return;
    }
    const nestedItems = listItem.querySelectorAll("li.active");
    nestedItems.forEach((nested) => {
      nested.classList.remove("active");
      const nestedLink = getDirectLink(nested);
      if (nestedLink) {
        nestedLink.classList.remove("active");
      }
    });
  };

  const closeSiblings = (listItem) => {
    const parentList = listItem ? listItem.parentElement : null;
    if (!parentList) {
      return;
    }

    Array.from(parentList.children).forEach((sibling) => {
      if (sibling === listItem) {
        return;
      }
      sibling.classList.remove("active");
      const siblingLink = getDirectLink(sibling);
      if (siblingLink) {
        siblingLink.classList.remove("active");
      }
      closeBranch(sibling);
    });
  };

  rootNav.addEventListener("click", function (event) {
    const itemTriggers = event.target.closest(".item_triggers");
    const link = itemTriggers
      ? itemTriggers.querySelector("a")
      : event.target.closest("a");

    if (!link) {
      return;
    }

    const listItem = link.closest("li");
    const submenu = getDirectSubmenu(listItem);
    if (!submenu) {
      return;
    }

    event.preventDefault();

    const isOpen =
      listItem.classList.contains("active") || link.classList.contains("active");

    if (isOpen) {
      listItem.classList.remove("active");
      link.classList.remove("active");
      closeBranch(listItem);
      return;
    }

    closeSiblings(listItem);
    listItem.classList.add("active");
    link.classList.add("active");
  });

  const offcanvasRoot = document.querySelector("#mobile-menu");
  if (offcanvasRoot) {
    offcanvasRoot.addEventListener("hidden", function () {
      rootNav.querySelectorAll("li.active").forEach((item) => {
        item.classList.remove("active");
      });
      rootNav.querySelectorAll("a.active").forEach((item) => {
        item.classList.remove("active");
      });
    });
  }
}

/**
 * Home Slider - Swiper.js Integration
 * Wymaga: swiper-bundle.min.js w vendors
 */
function initHomeSlider() {
  const sliderElement = document.querySelector('.ks_home_slider .swiper');
  
  if (!sliderElement) {
    return;
  }

  const swiper = new Swiper('.ks_home_slider .swiper', {
    // Efekt przejścia
    effect: 'slide',
    
    // Autoplay
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
      pauseOnMouseEnter: false,
    },
    
    // Loop
    loop: true,
    
    // Speed
    speed: 600,
    
    // Adaptive height - dostosowuje wysokość do aktywnego slajdu
    autoHeight: true,
    
    // Navigation arrows
    navigation: {
      nextEl: '.ks_home_slider .swiper-button-next',
      prevEl: '.ks_home_slider .swiper-button-prev',
    },
    
    // Pagination bullets
    pagination: {
      el: '.ks_home_slider .swiper-pagination',
      clickable: true,
    },
    
    // Accessibility
    a11y: {
      prevSlideMessage: 'Poprzedni slajd',
      nextSlideMessage: 'Następny slajd',
      paginationBulletMessage: 'Przejdź do slajdu {{index}}',
    },
  });

  // Log dla debug
  if (window.location.hostname === 'localhost' || window.location.hostname.includes('local')) {
    console.log('Home Slider initialized:', swiper);
  }
}

document.addEventListener("DOMContentLoaded", () => {
  // Initialize Swiper home slider
  if (document.querySelector('.ks_home_slider .swiper')) {
    initHomeSlider();
  }

  initDesktopMegaMenuLayout();
});

// Obsługa kliknięcia poza menu - zamyka aktywne kategorie
document.addEventListener("click", function (event) {
  if (!event.target.closest('[data-sub-item]')) {
    // Znajdź wszystkie elementy z klasą 'active' i atrybutem data-sub-item="00"
    const activeElements = document.querySelectorAll(
        'header .dropdown a[data-sub-item="00"].active'
    );
    
    // Znajdź również aktywne kategorie główne produktów
    const activeProductCategories = document.querySelectorAll(
        'header .depth-0 > a[data-sub-item].active'
    );

    if (activeElements) {
      // Usuń klasę 'active' z tych elementów
      activeElements.forEach(function (element) {
        element.classList.remove('active');
      });
    }
    
    if (activeProductCategories) {
      activeProductCategories.forEach(function (element) {
        element.classList.remove('active');
      });
    }
  }
});

//Form ask for availability
document.addEventListener("DOMContentLoaded", function () {
  var popup = document.getElementById("form-popup");
  var openPopupButton = document.getElementById("ask-availability-button");
  var closePopupButton = document.querySelector(".close-popup");

  if (openPopupButton) {
    openPopupButton.addEventListener("click", function (e) {
      e.preventDefault();
      popup.style.display = "flex";
    });
  }

  if (closePopupButton) {
    closePopupButton.addEventListener("click", function () {
      popup.style.display = "none";
    });
  }
});

document.addEventListener("DOMContentLoaded", function () {
  var formPopup = document.getElementById("form-popup");
  var responseOutput = document.querySelector(".wpcf7-response-output");

  // Sprawdź, czy popup istnieje i czy responseOutput nie jest pusty
  if (formPopup && responseOutput && responseOutput.textContent.trim() !== "") {
    // Wyświetl popup
    formPopup.style.display = "flex";
  }
  if (
      responseOutput &&
      responseOutput.innerText.trim() ===
      "Twoja wiadomość została wysłana. Dziękujemy!"
  ) {
    // Dodaj klasę 'sent' do .wpcf7
    if (formPopup) {
      formPopup.classList.add("sent");
    }
  }
});

document.addEventListener("DOMContentLoaded", function () {
  const toggleLink = document.querySelector("a.search_icon");
  const searchInput = document.querySelector("input.phrase");

  if (toggleLink && searchInput) {
    toggleLink.addEventListener("click", function () {
      setTimeout(function () {
        searchInput.focus();
      }, 400);
    });
  }
});

document.addEventListener("DOMContentLoaded", function () {
  var variation = document.querySelector(".variations");
  var labels = document.querySelectorAll(".variations .label label");

  labels.forEach(function (label) {
    if (label.textContent === "Model") {
      label.textContent = "Wybierz wariant:";
    }
  });

  if (variation !== null) {
    variation.style.display = "block";
  }
});

function updateMainMargin() {
  var header = document.querySelector("header");
  var main = document.querySelector("main");
  var searchMenu = document.querySelector('.search_result.menu ');

  if (header && main) {
    var headerHeight = header.offsetHeight;

    var totalHeight = headerHeight;
    main.style.marginTop = totalHeight + 'px';
  }
  if (header && searchMenu) {
    var headerHeight = header.offsetHeight;

    var totalHeight = headerHeight;
    searchMenu.style.marginTop = totalHeight + 'px';
  }

}
document.addEventListener("DOMContentLoaded", function() {
  updateMainMargin();
  window.addEventListener("resize", updateMainMargin);
});

function updateNoticeMargin() {
  var header = document.querySelector("header");
  var noticesWrapper = document.querySelector(".woocommerce-notices-wrapper");
  if (noticesWrapper && noticesWrapper.innerHTML.trim() !== '') {
    if (header && noticesWrapper) {
      var headerHeight = header.offsetHeight;
      var totalHeight = 16 + headerHeight;
      noticesWrapper.style.marginTop = totalHeight + 'px';
    }
  }
}

function handleNotices() {
  var noticesWrapper = document.querySelector(".woocommerce-notices-wrapper");

  if (noticesWrapper && noticesWrapper.innerHTML.trim() !== '') {
    // Show the notice
    noticesWrapper.style.opacity = '1';

    // Hide the notice after 5 seconds
    setTimeout(function() {
      noticesWrapper.style.opacity = '0';

      // Remove the notice content after 2 more seconds (7 seconds total)
      setTimeout(function() {
        noticesWrapper.innerHTML = '';
      }, 2000);
    }, 3000);
  }
}

document.addEventListener("DOMContentLoaded", function() {
  updateNoticeMargin();
  handleNotices();
  window.addEventListener("resize", updateNoticeMargin);
});


document.addEventListener("DOMContentLoaded", function() {
  const body = document.body;
  const html = document.documentElement;

  if (body.classList.contains('logged-in') && body.classList.contains('admin-bar')) {
    html.classList.add('logged-in-admin-bar');
  }
});

// Dodaj ten kod do pliku JavaScript lub umieść w tagach <script> na stronie

jQuery(document).ready(function($) {
  // Obiekt do przechowywania wybranych produktów
  let selectedProducts = {};

  // Obsługa przycisku dodawania SKU
  $('#add-sku-button').on('click', function(e) {
    e.preventDefault();
    const skuInput = $('#sku-input');
    const sku = skuInput.val().trim();

    if (!sku) {
      alert('Podaj SKU produktu.');
      return;
    }

    // Sprawdzenie czy SKU już istnieje
    if (selectedProducts[sku]) {
      alert('Ten produkt jest już dodany.');
      return;
    }

    // Zapytanie AJAX do WooCommerce, aby uzyskać informacje o produkcie
    $.ajax({
      url: woocommerce_params.ajax_url, // Poprawny URL do WordPress AJAX
      type: 'POST',
      data: {
        action: 'get_product_info',
        sku: sku,
        security: wc_form_nonce // Poprawny nonce
      },
      success: function(response) {
        if (response.success) {
          const product = response.data;
          addProductToList(sku, product.name);
          skuInput.val('');
        } else {
          alert('Nie znaleziono produktu o podanym SKU.');
        }
      },
      error: function() {
        alert('Wystąpił błąd podczas wyszukiwania produktu.');
      }
    });
  });

  // Umożliwienie dodawania produktu po naciśnięciu klawisza Enter
  $('#sku-input').on('keypress', function(e) {
    if (e.which === 13) {
      e.preventDefault();
      $('#add-sku-button').click();
    }
  });

  // Funkcja dodająca produkt do listy
  function addProductToList(sku, productName) {
    selectedProducts[sku] = {
      name: productName,
      quantity: 1
    };

    // Tworzenie nowego elementu produktu
    const productHTML = `
            <div class="product-item" data-sku="${sku}">
                <div class="product-info">
                    <span class="product-name">${productName}</span>
                    <span class="product-sku">(${sku})</span>
                </div>
                <div class="product-controls">
                    <label>Ilość: 
                        <input type="number" class="quantity-input" value="1" min="1" max="999">
                    </label>
                    <button type="button" class="remove-product">Usuń</button>
                </div>
            </div>
        `;

    $('#selected-products-container').append(productHTML);
    updateProductsList();

    // Obsługa zmiany ilości
    $('.quantity-input').off('change').on('change', function() {
      const productItem = $(this).closest('.product-item');
      const sku = productItem.data('sku');
      const quantity = parseInt($(this).val());

      if (quantity < 1) $(this).val(1);
      if (quantity > 999) $(this).val(999);

      selectedProducts[sku].quantity = parseInt($(this).val());
      updateProductsList();
    });

    // Obsługa usuwania produktu
    $('.remove-product').off('click').on('click', function() {
      const productItem = $(this).closest('.product-item');
      const sku = productItem.data('sku');

      delete selectedProducts[sku];
      productItem.remove();
      updateProductsList();
    });
  }

  // Aktualizacja ukrytego pola z listą produktów
  function updateProductsList() {
    let productsList = [];

    Object.keys(selectedProducts).forEach(sku => {
      productsList.push(`${sku} - ${selectedProducts[sku].name} (Ilość: ${selectedProducts[sku].quantity})`);
    });

    $('#produkty-lista').val(productsList.join('\n'));
  }

  // Obsługa przeciągnij i upuść dla plików
  const fileUpload = $('.file-upload');

  fileUpload.on('dragover', function(e) {
    e.preventDefault();
    e.stopPropagation();
    $(this).css('border-color', '#CB0015');
  });

  fileUpload.on('dragleave', function(e) {
    e.preventDefault();
    e.stopPropagation();
    $(this).css('border-color', '#CECECE');
  });

  // Obsługa zdarzenia zmiany pliku
  $('input[name="zalacznik"]').on('change', function() {
    const fileName = $(this).val().split('\\').pop();
    if (fileName) {
      $(this).siblings('p').text('Wybrany plik: ' + fileName);
    } else {
      $(this).siblings('p').text('Przeciągnij i upuść plik lub');
    }
  });

  // Walidacja formularza przed wysłaniem
  document.addEventListener('wpcf7submit', function(event) {
    const formData = event.detail.inputs;
    const produktyLista = formData.find(input => input.name === 'produkty_lista');

    if (!produktyLista || !produktyLista.value) {
      alert('Proszę dodać co najmniej jeden produkt.');
      event.preventDefault();
    }
  }, false);
});